<app-text-input
  (ngModelChange)="onSearchChange($event)"
  [label]="vm.label"
  [placeHolder]="vm.placeHolder || 'Start typing here...'"
  [ngModel]="searchTerm"
  [ngModelOptions]="{ standalone: true }"
  (inputFocused)="showOptions.set(true)"
  [error]="vm.errors"
  name="search-holder"
  [class]="vm.textInputClasses"
  dataTestId="text-search-input"
>
  @if (vm.searchIconPosition === 'start') {
    <i icon-start class="fa-regular fa-search"></i>
  }
  @if (vm.loading) {
    <app-loading-spinner icon-end [size]="20" />
  } @else if (searchTerm && searchTerm !== '') {
    <i icon-end class="fa-regular fa-xmark fa-lg pointer" (click)="onSearchChange('')"></i>
  }
</app-text-input>

@if (vm.exampleText) {
  <p class="hint mt-4" data-testid="text-search-hint">{{ vm.exampleText }}</p>
}

@if (value && !apiError()) {
  @let mappedValue = vm.mappedValues?.[vm.valueForMappedLookup] ?? vm.mappedValues?.[vm.name];
  @let labelText = value.dataLabel ?? mappedValue?.dataLabel ?? mappedValue?.title;
  <section [class]="'selected-item flex-col gap-8 mt-16 ' + vm.textInputClasses">
    <section class="flex">
      <p class="label">{{ vm.selectedLabel | firstLetterCapitalise }}</p>

      <button type="button" class="link-text" (click)="writeValue(undefined)">
        <span> Remove </span>
        <i class="fa-light fa-trash ml-8"></i>
      </button>
    </section>

    <p class="body">
      <i class="fa-light fa-circle-check mr-8"></i>
      {{ labelText | firstLetterCapitalise }}
    </p>
  </section>
}

<ng-content select="[errors-content]"></ng-content>
<ng-content></ng-content>

@if (apiError()) {
  <section class="text-search-error api-error" data-testid="search-unavailable-error-message">
    <section class="heading">
      <i class="fa-light fa-triangle-exclamation"></i>
      <p class="body bold" data-testid="search-unavailable-error-title">Search is temporarily unavailable</p>
    </section>
    <p class="body" data-testid="search-unavailable-error-description">
      We're having trouble connecting to our system. <ng-content select="[api-error-description]"></ng-content>
    </p>
  </section>
} @else if (searchTerm.trim().length >= 3 && !vm.loading && !vm.options.length && !vm.hideNoResultsHint) {
  <section class="text-search-error no-results-found" data-testid="no-results-found-error-message">
    <section class="heading">
      <i class="fa-light fa-circle-exclamation"></i>
      <p class="body bold" data-testid="no-results-found-error-title">No results found</p>
    </section>
    <p class="body" data-testid="no-results-found-error-description">
      <ng-content select="[no-results-description]"></ng-content>
    </p>
  </section>
} @else if (searchTerm !== '' && vm.options.length && vm.showOptions) {
  <p class="hint mt-8">{{ vm.options.length }} result{{ vm.options.length === 1 ? '' : 's' }}</p>
}

@if (searchTerm.length && vm.showOptions && vm.options.length) {
  <section #scrollElement class="scroll-container mt-12 sm-mt-8" data-testid="text-search-option-list">
    <section class="pt-4 pb-4" [style.height.px]="virtualiser?.getTotalSize()">
      @for (option of vm.options; track option.value; let index = $index) {
        <app-radio-button
          (ngModelChange)="!$event ? null : handleRadioSelection($event)"
          [index]="index"
          [includeResetOption]="false"
          [optionValue]="option.value | stringify"
          [ngModel]="value | stringify"
          [ngModelOptions]="{ standalone: true }"
          (mouseup)="hideOptions()"
          class="flex mb-8"
          variant="select"
          dataTestId="text-search-option"
        >
          <p class="body radio-text">{{ option.title | firstLetterCapitalise }}</p>
        </app-radio-button>
      }
    </section>
  </section>
}

<input hidden type="text" [ngModel]="value" [name]="vm.name" />
